// ABOUTME: Icon component for water drop used to represent hydration
// ABOUTME: Supports className, size, and color customization

interface IconProps {
  className?: string
  size?: number
  color?: string
}

export const HydrateIcon = ({ className = "", size = 21, color = "#00C2FF" }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 15"
    fill="none"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.43 0.385508C6.30396 0.297307 6.15384 0.25 6 0.25C5.84616 0.25 5.69604 0.297307 5.57 0.385508C4.60358 1.09774 3.7194 1.91527 2.93375 2.82301C1.17813 4.83926 0.25 6.97613 0.25 8.99988C0.25 10.5249 0.855802 11.9874 1.93414 13.0657C3.01247 14.1441 4.47501 14.7499 6 14.7499C7.52499 14.7499 8.98753 14.1441 10.0659 13.0657C11.1442 11.9874 11.75 10.5249 11.75 8.99988C11.75 4.16488 6.6475 0.537383 6.43 0.385508ZM6 13.2499C4.87319 13.2487 3.79285 12.8006 2.99608 12.0038C2.1993 11.207 1.75116 10.1267 1.75 8.99988C1.75 6.91801 3 5.03926 4.04375 3.83051C4.63967 3.146 5.29424 2.51485 6 1.94426C6.70576 2.51485 7.36033 3.146 7.95625 3.83051C9 5.03926 10.25 6.91801 10.25 8.99988C10.2488 10.1267 9.8007 11.207 9.00392 12.0038C8.20715 12.8006 7.12681 13.2487 6 13.2499ZM9.10125 9.97488C8.94425 10.474 8.66908 10.9278 8.29912 11.2978C7.92916 11.6677 7.47534 11.9429 6.97625 12.0999C6.90339 12.1225 6.82755 12.1341 6.75125 12.1343C6.57197 12.1344 6.39857 12.0703 6.26247 11.9536C6.12638 11.8369 6.0366 11.6753 6.00939 11.4981C5.98219 11.3209 6.01936 11.1398 6.11418 10.9876C6.209 10.8354 6.35518 10.7223 6.52625 10.6686C6.79522 10.5841 7.03979 10.4359 7.23915 10.2365C7.4385 10.0372 7.58674 9.7926 7.67125 9.52363C7.7008 9.42966 7.74857 9.34242 7.81183 9.2669C7.87509 9.19139 7.95261 9.12907 8.03995 9.08351C8.21635 8.9915 8.42208 8.97334 8.61187 9.03301C8.70585 9.06256 8.79309 9.11032 8.86861 9.17359C8.94412 9.23685 9.00644 9.31436 9.052 9.40171C9.09756 9.48905 9.12547 9.58452 9.13413 9.68265C9.1428 9.78078 9.13205 9.87966 9.1025 9.97363L9.10125 9.97488Z"
      fill={color}
    />
  </svg>
)
